<template>
  <div>
    <div class="slider">
      <div class="slider-validate">
        <span
            class="icon is-small is-right has-text-danger"
            v-if="!fieldValidator && field.validation.required"
        >
          <fa icon="asterisk" class="fa-xs"></fa>
        </span>
        <span
            class="icon is-small is-right has-text-success"
            v-if="fieldValidator"
        >
          <fa icon="check"></fa>
        </span>
      </div>

      <div class="columns slider-labels is-italic has-text-grey is-mobile">
        <div class="column is-one-third has-text-left">{{field.labels.leftSide}}</div>
        <div class="column is-one-third has-text-centered">{{field.labels.center}}</div>
        <div class="column is-one-third has-text-right">{{field.labels.rightSide}}</div>
      </div>
      <input
            :id="`${field.name}-field`"
            :refs="`${field.name}-field`"
            :name="field.name"
            class="
              slider
              is-fullwidth
              is-large
              slider-input
              tooltip
              is-tooltip-bottom
              is-tooltip-danger
            "
            :step="field.step"
            :min="field.min"
            :max="field.max"
            type="range"
            @change="updateFormData"
            @click="updateFormData"
            v-touch="updateFormData"
            data-tooltip="Please fill out this field."
      >
      <div class="slider-ticks">
        <!-- eslint-disable-next-line -->
        <span class="slider-tick" v-for="n in tickCount"></span>
      </div>
    </div>
    <p class="help is-danger" v-if="errors.has(field.name)">
      {{ errors.first(field.name) }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasAnswered: false,
    };
  },
  props: {
    field: {
      type: Object,
      required: true,
      default() {
        return {
          min: 1,
          max: 7,
          step: 1,
          labels: {
            leftSide: 'Strongly Disagree',
            center: 'Neutral',
            rightSide: 'Strongly Agree',
          },
        };
      },
    },
  },
  computed: {
    fieldValidator() {
      return this.hasAnswered;
      // if (this.fieldValidator) {
      //   return !this.errors.has(this.field.name) && this.fieldValidator.value;
      // }
      // return false;
    },
    tickCount() {
      return (this.field.max - (this.field.min === 1 ? 0 : this.field.min)) / this.field.step;
    },
  },
  methods: {
    updateFormData(e) {
      const fieldStore = {
        name: e.target.name,
        value: e.target.value,
      };
      this.hasAnswered = true;
      this.$store.dispatch('addToSubmission', fieldStore);
      this.$store.state.manual_required_check[this.field.name] = true;
    },
  },
  mounted() {
    const fieldStore = {
      name: this.field.name,
      value: null,
    };
    this.$store.dispatch('addToSubmission', fieldStore);

    this.$store.state.manual_required_check[this.field.name] = false;
  },
};
</script>
